exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg {\n  max-width: 150px;\n}\n.ant-popover-inner-content{\n  padding: 8px;\n}\n", ""]);

// exports
